import { errorToast, neutralToast } from '@/lib/toast'

export const displayError = (title: string, message: string) => {
  errorToast(
    <div className="flex flex-col gap-1">
      <div className="text-sm font-bold">{title}</div>
      <div className="text-sm">{message}</div>
    </div>
  )
}

// Neutral, non-error notice — same layout as displayError but rendered as a
// neutral toast. Used for expected events such as a session that has expired.
export const displayInfo = (title: string, message: string) => {
  neutralToast(
    <div className="flex flex-col gap-1">
      <div className="text-sm font-bold">{title}</div>
      <div className="text-sm">{message}</div>
    </div>
  )
}
